interface FertilizerCoverageDiagramProps {
  pounds: number
  bags: number
  bagSize: number
  lawnSize: number
}

/** Purchase quantity and application quantity are different engine outputs. */
export function FertilizerCoverageDiagram({ pounds, bags, bagSize, lawnSize }: FertilizerCoverageDiagramProps) {
  if (![pounds, bags, bagSize, lawnSize].every(Number.isFinite) || pounds <= 0 || bagSize <= 0 || lawnSize <= 0) return null
  const amount = pounds.toLocaleString(undefined, { maximumFractionDigits: 1 })
  return (
    <figure aria-label="Fertilizer quantity and lawn area" className="mt-5 rounded-2xl bg-white/80 p-4">
      <dl className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,12rem),1fr))] gap-4">
        <div className="grid min-w-0 grid-cols-[3rem_minmax(0,1fr)] items-center gap-x-3">
          <svg viewBox="0 0 72 56" className="row-span-2 h-10 w-12 text-action" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <path d="M21 9h30l-3 8 6 28q0 3-4 3H22q-4 0-4-3l6-28z" fill="var(--color-green-50)" />
            <path d="M24 17h24M29 30q7 0 7 9 0-12 9-13M36 39v4" />
          </svg>
          <dt className="text-xs font-semibold text-gray-600">Buy</dt>
          <dd className="mt-1 break-words font-semibold tabular-nums text-green-900">{bags} × {bagSize}-lb {bags === 1 ? 'bag' : 'bags'}</dd>
        </div>
        <div className="grid min-w-0 grid-cols-[3rem_minmax(0,1fr)] items-center gap-x-3">
          <svg viewBox="0 0 72 56" className="row-span-2 h-10 w-12 text-action" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <path d="m21 10 28 9-9 17-19-6z" fill="var(--color-green-50)" />
            <path d="m49 19 8-6M26 39v1m10 3v1m10-6v1m-26 7v1m32-1v1M14 51h44" />
          </svg>
          <dt className="text-xs font-semibold text-gray-600">Spread</dt>
          <dd className="mt-1 break-words font-semibold tabular-nums text-green-900">{amount} lbs total</dd>
        </div>
        <div className="grid min-w-0 grid-cols-[3rem_minmax(0,1fr)] items-center gap-x-3">
          <svg viewBox="0 0 72 56" className="row-span-2 h-10 w-12 text-action" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <rect x="10" y="9" width="52" height="38" rx="6" fill="var(--color-green-50)" />
            <path d="M22 30v-9m0 6-4-4m4 2 4-4m10 13v-9m0 6-4-4m4 2 4-4m10 7v-9m0 6-4-4m4 2 4-4" />
          </svg>
          <dt className="text-xs font-semibold text-gray-600">Lawn area</dt>
          <dd className="mt-1 break-words font-semibold tabular-nums text-green-900">{lawnSize.toLocaleString()} sq ft</dd>
        </div>
      </dl>
    </figure>
  )
}
